<template>
    <div>
        <v-card :loading="loading" class="mx-auto" outlined>
            <template v-slot:progress>
                <v-progress-linear
                    :color="$globalSettings.progressbarClasses"
                    height="10"
                    indeterminate
                ></v-progress-linear>
            </template>

            <v-card-title>
                <v-row>
                    <v-col cols="12" sm="12">
                        <div v-if="reportType === 'dateWise'">
                            <span class="secondary-text">1. Date wise Report</span>
                            <button type="button" class="btn btn-sm btn-outline-secondary float-right mr-5" v-on:click="exportToXLSX('reports.dateWise')"><i class="fas fa-file-excel"></i> Export Excel</button>
                            <button type="button" class="btn btn-sm btn-outline-secondary float-right mr-5" v-on:click="exportPDF('reports.dateWise')"><i class="fas fa-file-pdf"></i> Export PDF</button>
                        </div>
                        <div v-if="reportType === 'companyWise'">
                            <span class="secondary-text">2. Company wise Report</span>
                            <button type="button" class="btn btn-sm btn-outline-secondary float-right mr-5" v-on:click="exportToXLSX('reports.companyWise')"><i class="fas fa-file-excel"></i> Export Excel</button>
                            <button type="button" class="btn btn-sm btn-outline-secondary float-right mr-5" v-on:click="exportPDF('reports.companyWise')"><i class="fas fa-file-pdf"></i> Export PDF</button>
                        </div>
                        <div v-if="reportType === 'categoryWise'">
                            <span class="secondary-text">3. Category wise Report</span>
                            <button type="button" class="btn btn-sm btn-outline-secondary float-right mr-5" v-on:click="exportToXLSX('reports.categoryWise')"><i class="fas fa-file-excel"></i> Export Excel</button>
                            <button type="button" class="btn btn-sm btn-outline-secondary float-right mr-5" v-on:click="exportPDF('reports.categoryWise')"><i class="fas fa-file-pdf"></i> Export PDF</button>
                        </div>
                        <div v-if="reportType === 'summaryWise'">
                            <span class="secondary-text">4. Summary Report</span>
                            <button type="button" class="btn btn-sm btn-outline-secondary float-right mr-5" v-on:click="exportToXLSX('reports.summaryWise')"><i class="fas fa-file-excel"></i> Export Excel</button>
                            <button type="button" class="btn btn-sm btn-outline-secondary float-right mr-5" v-on:click="exportPDF('reports.summaryWise')"><i class="fas fa-file-pdf"></i> Export PDF</button>
                        </div>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <v-row v-if="reportType === 'dateWise'">
                    <v-col>
                        <v-menu v-model="calendar1Open" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field dense outlined :value="reports.dateWise.startDate && $globalHelpers.getFormattedDate(reports.dateWise.startDate, '', 'MMMM D, YYYY')" label="From" readonly v-bind="attrs" v-on="on" clearable @click:clear="reports.dateWise.startDate = null" prepend-icon="fa-regular fa-calendar"></v-text-field>
                            </template>
                            <v-date-picker v-model="reports.dateWise.startDate">
                                <v-btn text color="primary" @click="calendar1Open = false">Close</v-btn>
                            </v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col>
                        <v-menu v-model="calendar2Open" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field dense outlined :value="reports.dateWise.endDate && $globalHelpers.getFormattedDate(reports.dateWise.endDate, '', 'MMMM D, YYYY')" label="To" readonly v-bind="attrs" v-on="on" clearable @click:clear="reports.dateWise.endDate = null" prepend-icon="fa-regular fa-calendar"></v-text-field>
                            </template>
                            <v-date-picker v-model="reports.dateWise.endDate">
                                <v-btn text color="primary" @click="calendar2Open = false">Close</v-btn>
                            </v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col>
                        <v-select dense outlined :items="statuses" item-value="id" item-text="label" label="Incentive Status" v-model="reports.dateWise.selectedStatusIds" multiple small-chips>
                            <template v-slot:prepend-item>
                                <v-list-item ripple @mousedown.prevent @click="toggleSelection('reports.dateWise.selectedStatusIds')">
                                    <v-list-item-action>
                                        <v-icon :color="reports.dateWise.selectedStatusIds.length > 0 ? 'indigo darken-4' : ''">fa-regular fa-square-check</v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            Select All
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider class="mt-2"></v-divider>
                            </template>
                            <template v-slot:selection="{ item, index }">
                                <v-chip v-if="index === 0" small><span>{{ item.label }}</span></v-chip>
                                <span v-if="index === 1" class="grey--text text-caption">(+{{ reports.dateWise.selectedStatusIds.length - 1 }} others)</span>
                            </template>
                        </v-select>
                    </v-col>
                    <v-col>
                        <v-btn class="float-end" color="primary" @click="generate('reports.dateWise')">Generate</v-btn>
                    </v-col>
                </v-row>

                <v-row v-if="reportType === 'companyWise'">
                    <v-col>
                        <v-text-field dense outlined v-model="reports.companyWise.Username" type="text" label="Exporter Number" hint="ex. BD00001/NT00001" :disabled="loading" required></v-text-field>
                    </v-col>
                    <v-col>
                        <v-menu v-model="calendar1Open" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto" clo>
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field dense outlined :value="reports.companyWise.startDate && $globalHelpers.getFormattedDate(reports.companyWise.startDate, '', 'MMMM D, YYYY')" label="From" readonly v-bind="attrs" v-on="on" clearable @click:clear="reports.companyWise.startDate = null" prepend-icon="fa-regular fa-calendar"></v-text-field>
                            </template>
                            <v-date-picker v-model="reports.companyWise.startDate">
                                <v-btn text color="primary" @click="calendar1Open = false">Close</v-btn>
                            </v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col>
                        <v-menu v-model="calendar2Open" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field dense outlined :value="reports.companyWise.endDate && $globalHelpers.getFormattedDate(reports.companyWise.endDate, '', 'MMMM D, YYYY')" label="To" readonly v-bind="attrs" v-on="on" clearable @click:clear="reports.companyWise.endDate = null" prepend-icon="fa-regular fa-calendar"></v-text-field>
                            </template>
                            <v-date-picker v-model="reports.companyWise.endDate">
                                <v-btn text color="primary" @click="calendar2Open = false">Close</v-btn>
                            </v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col>
                        <v-select dense outlined :items="statuses" item-value="id" item-text="label" label="Incentive Status" v-model="reports.companyWise.selectedStatusIds" multiple small-chips>
                            <template v-slot:prepend-item>
                                <v-list-item ripple @mousedown.prevent @click="toggleSelection('reports.companyWise.selectedStatusIds')">
                                    <v-list-item-action>
                                        <v-icon :color="reports.companyWise.selectedStatusIds.length > 0 ? 'indigo darken-4' : ''">fa-regular fa-square-check</v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            Select All
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider class="mt-2"></v-divider>
                            </template>
                            <template v-slot:selection="{ item, index }">
                                <v-chip v-if="index === 0" small><span>{{ item.label }}</span></v-chip>
                                <span v-if="index === 1" class="grey--text text-caption">(+{{ reports.companyWise.selectedStatusIds.length - 1 }} others)</span>
                            </template>
                        </v-select>
                    </v-col>
                    <v-col>
                        <v-btn class="float-end" color="primary" @click="generate('reports.companyWise')" :disabled="!reports.companyWise.Username || reports.companyWise.Username.length < 7">Generate</v-btn>
                    </v-col>
                </v-row>

                <v-row v-if="reportType === 'categoryWise'">
                    <v-col>
                        <v-select dense outlined v-model="reports.categoryWise.incentiveTypeId" :items="$globalSettings.svFormIncentiveTypes" item-value="id" item-text="label" label="Category *" :disabled="loading"></v-select>
                    </v-col>
                    <v-col>
                        <v-menu v-model="calendar1Open" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field dense outlined :value="reports.categoryWise.startDate && $globalHelpers.getFormattedDate(reports.categoryWise.startDate, '', 'MMMM D, YYYY')" label="From" readonly v-bind="attrs" v-on="on" clearable @click:clear="reports.categoryWise.startDate = null" prepend-icon="fa-regular fa-calendar"></v-text-field>
                            </template>
                            <v-date-picker v-model="reports.categoryWise.startDate">
                                <v-btn text color="primary" @click="calendar1Open = false">Close</v-btn>
                            </v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col>
                        <v-menu v-model="calendar2Open" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field dense outlined :value="reports.categoryWise.endDate && $globalHelpers.getFormattedDate(reports.categoryWise.endDate, '', 'MMMM D, YYYY')" label="To" readonly v-bind="attrs" v-on="on" clearable @click:clear="reports.categoryWise.endDate = null" prepend-icon="fa-regular fa-calendar"></v-text-field>
                            </template>
                            <v-date-picker v-model="reports.categoryWise.endDate">
                                <v-btn text color="primary" @click="calendar2Open = false">Close</v-btn>
                            </v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col>
                        <v-select dense outlined :items="statuses" item-value="id" item-text="label" label="Incentive Status" v-model="reports.categoryWise.selectedStatusIds" multiple small-chips>
                            <template v-slot:prepend-item>
                                <v-list-item ripple @mousedown.prevent @click="toggleSelection('reports.categoryWise.selectedStatusIds')">
                                    <v-list-item-action>
                                        <v-icon :color="reports.categoryWise.selectedStatusIds.length > 0 ? 'indigo darken-4' : ''">fa-regular fa-square-check</v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            Select All
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider class="mt-2"></v-divider>
                            </template>
                            <template v-slot:selection="{ item, index }">
                                <v-chip v-if="index === 0" small><span>{{ item.label }}</span></v-chip>
                                <span v-if="index === 1" class="grey--text text-caption">(+{{ reports.categoryWise.selectedStatusIds.length - 1 }} others)</span>
                            </template>
                        </v-select>
                    </v-col>
                    <v-col>
                        <v-btn class="float-end" color="primary" @click="generate('reports.categoryWise')" :disabled="reports.categoryWise.incentiveTypeId === 0">Generate</v-btn>
                    </v-col>
                </v-row>

                <v-row v-if="reportType === 'summaryWise'">
                    <v-col>
                        <v-menu v-model="calendar1Open" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field dense outlined :value="reports.summaryWise.startDate && $globalHelpers.getFormattedDate(reports.summaryWise.startDate, '', 'MMMM D, YYYY')" label="From" readonly v-bind="attrs" v-on="on" clearable @click:clear="reports.summaryWise.startDate = null" prepend-icon="fa-regular fa-calendar"></v-text-field>
                            </template>
                            <v-date-picker v-model="reports.summaryWise.startDate">
                                <v-btn text color="primary" @click="calendar1Open = false">Close</v-btn>
                            </v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col>
                        <v-menu v-model="calendar2Open" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field dense outlined :value="reports.summaryWise.endDate && $globalHelpers.getFormattedDate(reports.summaryWise.endDate, '', 'MMMM D, YYYY')" label="To" readonly v-bind="attrs" v-on="on" clearable @click:clear="reports.summaryWise.endDate = null" prepend-icon="fa-regular fa-calendar"></v-text-field>
                            </template>
                            <v-date-picker v-model="reports.summaryWise.endDate">
                                <v-btn text color="primary" @click="calendar2Open = false">Close</v-btn>
                            </v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col>
                        <v-btn class="float-end" color="primary" @click="generate('reports.summaryWise')">Generate</v-btn>
                    </v-col>
                </v-row>
<div id="debugReport"></div>
                <v-row v-if="reportType === 'dateWise' && showReport">
                    <v-col cols="12" sm="12">
                        <table class="report_table" id="reports.dateWise">
                            <tbody>
                            <tr>
                                <td class="text-left font-bold">SL#</td>
                                <td class="text-left font-bold">ID</td>
                                <td class="text-left font-bold">Category</td>
                                <td class="text-left font-bold">Company</td>
                                <td class="text-left font-bold">Importer</td>
                                <td class="text-left font-bold">Country</td>
                                <td class="text-left font-bold">HS Code</td>
                                <td class="text-left font-bold">Repatriated Value</td>
                                <td class="text-left font-bold">Net FOB Value</td>
                                <td class="text-left font-bold">Status</td>
                                <td class="text-left font-bold">Date</td>
                            </tr>
                            <tr v-for="(item, i) in reports.dateWise.list" :key="i">
                                <td>{{ i + 1 }}</td>
                                <td>{{ item.Id }}</td>
                                <td>{{ ($globalSettings.svFormIncentiveTypes.find(c => c.id === item.IncentiveTypeId) || {}).label || '' }}</td>
                                <td>{{ item.SvForm.User.OrganizationName }}</td>
                                <td>{{ item.SvForm.Importer.Name }}</td>
                                <td>{{ ($globalSettings.countries.find(c => c.id === item.SvForm.Importer.CountryId) || {}).name || '' }}</td>
                                <td><span v-for="(svFormHSCode, i) in item.SvForm.SvFormHSCodes" :key="i">{{ svFormHSCode.HSCode.Code }}, </span> </td>
                                <td>{{ item.RepatriatedValue }}</td>
                                <td>{{ item.RealisedNetFOBValue }}</td>
                                <td>{{ $globalHelpers.humanize($globalHelpers.getSvFormStatusName(item.StatusId, $globalEnums.SvFormTypes.Incentive)) }}</td>
                                <td>{{ $globalHelpers.getFormattedDate(item.Modified, '', 'DD/MM/YYYY') }}</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>Total:</td>
                                <td colspan="10">{{ reports.dateWise.count }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </v-col>
                </v-row>

                <v-row v-if="reportType === 'companyWise' && showReport">
                    <v-col cols="12" sm="12">
                        <table class="report_table font-size-12" id="reports.companyWise">
                            <tbody>
                            <tr>
                                <td class="text-left font-bold">SL#</td>
                                <td class="text-left font-bold">ID</td>
                                <td class="text-left font-bold">Category</td>
                                <td class="text-left font-bold">Importer</td>
                                <td class="text-left font-bold">Country</td>
                                <td class="text-left font-bold">HS Code</td>
                                <td class="text-left font-bold">Repatriated Value</td>
                                <td class="text-left font-bold">Net FOB Value</td>
                                <td class="text-left font-bold">Status</td>
                                <td class="text-left font-bold">Date</td>
                            </tr>
                            <tr v-for="(item, i) in reports.companyWise.list" :key="i">
                                <td>{{ i + 1 }}</td>
                                <td>{{ item.Id }}</td>
                                <td>{{ ($globalSettings.svFormIncentiveTypes.find(c => c.id === item.IncentiveTypeId) || {}).label || '' }}</td>
                                <td>{{ item.SvForm.Importer.Name }}</td>
                                <td>{{ ($globalSettings.countries.find(c => c.id === item.SvForm.Importer.CountryId) || {}).name || '' }}</td>
                                <td><span v-for="(svFormHSCode, i) in item.SvForm.SvFormHSCodes" :key="i">{{ svFormHSCode.HSCode.Code }},</span> </td>
                                <td>{{ item.RepatriatedValue }}</td>
                                <td>{{ item.RealisedNetFOBValue }}</td>
                                <td>{{ $globalHelpers.humanize($globalHelpers.getSvFormStatusName(item.StatusId, $globalEnums.SvFormTypes.Incentive)) }}</td>
                                <td>{{ $globalHelpers.getFormattedDate(item.Modified, '', 'MMMM D, YYYY') }}</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>Total:</td>
                                <td colspan="9">{{ reports.companyWise.count }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </v-col>
                </v-row>

                <v-row v-if="reportType === 'categoryWise' && showReport">
                    <v-col cols="12" sm="12">
                        <table class="report_table font-size-12" id="reports.categoryWise">
                            <tbody>
                            <tr>
                                <td class="text-left font-bold">SL#</td>
                                <td class="text-left font-bold">ID</td>
                                <td class="text-left font-bold">Company</td>
                                <td class="text-left font-bold">Importer</td>
                                <td class="text-left font-bold">Country</td>
                                <td class="text-left font-bold">HS Code</td>
                                <td class="text-left font-bold">Repatriated Value</td>
                                <td class="text-left font-bold">Net FOB Value</td>
                                <td class="text-left font-bold">Status</td>
                                <td class="text-left font-bold">Date</td>
                            </tr>
                            <tr v-for="(item, i) in reports.categoryWise.list" :key="i">
                                <td>{{ i + 1 }}</td>
                                <td>{{ item.Id }}</td>
                                <td>{{ item.SvForm.User.OrganizationName }}</td>
                                <td>{{ item.SvForm.Importer.Name }}</td>
                                <td>{{ ($globalSettings.countries.find(c => c.id === item.SvForm.Importer.CountryId) || {}).name || '' }}</td>
                                <td><span v-for="(svFormHSCode, i) in item.SvForm.SvFormHSCodes" :key="i">{{ svFormHSCode.HSCode.Code }},</span> </td>
                                <td>{{ item.RepatriatedValue }}</td>
                                <td>{{ item.RealisedNetFOBValue }}</td>
                                <td>{{ $globalHelpers.humanize($globalHelpers.getSvFormStatusName(item.StatusId, $globalEnums.SvFormTypes.Incentive)) }}</td>
                                <td>{{ $globalHelpers.getFormattedDate(item.Modified, '', 'MMMM D, YYYY') }}</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>Total:</td>
                                <td colspan="9">{{ reports.categoryWise.count }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </v-col>
                </v-row>

                <v-row v-if="reportType === 'summaryWise' && showReport">
                    <v-col cols="12" sm="12">
                        <table class="report_table font-size-12" id="reports.summaryWise">
                            <tbody>
                            <tr>
                                <td class="text-left font-bold" style="width: 5%;">SL#</td>
                                <td class="text-left font-bold">Category</td>
                                <td class="text-right font-bold" style="text-align: right; padding-right: 5px; width: 10%;">Approved Count</td>
                            </tr>
                            <tr v-for="(item, i) in reports.summaryWise.list" :key="i">
                                <td>{{ i + 1 }}</td>
                                <td>{{ ($globalSettings.svFormIncentiveTypes.find(c => c.id === item.IncentiveTypeId) || {}).label || '' }}</td>
                                <td class="text-right" style="text-align: right; padding-right: 5px;">{{ item.Count }}</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td class="text-right">Total:</td>
                                <td class="text-right" style="text-align: right; padding-right: 5px;">{{ reports.summaryWise.count }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </v-col>
                </v-row>

            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import Vue from "vue";
import html2pdf from 'html2pdf.js';
import XLSX from "xlsx";

export default {
    name: "Reports_view",
    components: {},
    data: () => ({
        loading: false,

        calendar1Open: false,
        calendar2Open: false,
        reportType: null,
        showReport: false,
        statuses: [],

        reports:{
            dateWise:{
                reportName: '1. Date wise Report',
                startDate: null,
                endDate: null,
                selectedStatusIds: [],
                list: [],
                count: 0,
                defaultTotals: {
                    RepatriatedValue: 0,
                    RealisedNetFOBValue: 0,
                },
            },
            companyWise:{
                reportName: '2. Company wise Report',
                Username: null,
                startDate: null,
                endDate: null,
                selectedStatusIds: [],
                list: [],
                count: 0,
                companyName: null,
                defaultTotals: {
                    RepatriatedValue: 0,
                    RealisedNetFOBValue: 0,
                },
            },
            categoryWise:{
                reportName: '3. Category wise Report',
                incentiveTypeId: 0,
                startDate: null,
                endDate: null,
                selectedStatusIds: [],
                list: [],
                count: 0,
                defaultTotals: {
                    RepatriatedValue: 0,
                    RealisedNetFOBValue: 0,
                },
            },
            summaryWise:{
                reportName: '4. Summary Report',
                startDate: null,
                endDate: null,
                selectedStatusIds: [],
                incentiveTypeIds: [],
                list: [],
                count: 0,
                defaultTotals: {
                },
            },
        },

        reportMap: {
            'reports.dateWise': {
                elementId: 'reports.dateWise',
                filenamePDF: 'Incentive_Report_date_wise.pdf',
                filenameExcel: 'Incentive_Report_date_wise.xlsx',
                title: '1. Date wise',
                reportKey: 'dateWise'
            },
            'reports.companyWise': {
                elementId: 'reports.companyWise',
                filenamePDF: 'Incentive_Report_company_wise.pdf',
                filenameExcel: 'Incentive_Report_company_wise.xlsx',
                title: '2. Company wise',
                reportKey: 'companyWise'
            },
            'reports.categoryWise': {
                elementId: 'reports.categoryWise',
                filenamePDF: 'Incentive_Report_category_wise.pdf',
                filenameExcel: 'Incentive_Report_category_wise.xlsx',
                title: '3. Category wise',
                reportKey: 'categoryWise'
            },
            'reports.summaryWise': {
                elementId: 'reports.summaryWise',
                filenamePDF: 'Incentive_Report_summary.pdf',
                filenameExcel: 'Incentive_Report_summary.xlsx',
                title: '4. Summary',
                reportKey: 'summaryWise'
            }
        },
    }),
    methods:{
        toggleSelection: function(field){
            if(field === 'reports.dateWise.selectedStatusIds'){
                this.$nextTick(() => {
                    if (this.reports.dateWise.selectedStatusIds.length === this.statuses.length) {
                        this.reports.dateWise.selectedStatusIds = []
                    } else {
                        this.reports.dateWise.selectedStatusIds = this.$globalHelpers.pluck(this.statuses, 'id');
                    }
                })
            }
            else if(field === 'reports.companyWise.selectedStatusIds'){
                this.$nextTick(() => {
                    if (this.reports.companyWise.selectedStatusIds.length === this.statuses.length) {
                        this.reports.companyWise.selectedStatusIds = []
                    } else {
                        this.reports.companyWise.selectedStatusIds = this.$globalHelpers.pluck(this.statuses, 'id');
                    }
                })
            }
            else if(field === 'reports.categoryWise.selectedStatusIds'){
                this.$nextTick(() => {
                    if (this.reports.categoryWise.selectedStatusIds.length === this.statuses.length) {
                        this.reports.categoryWise.selectedStatusIds = []
                    } else {
                        this.reports.categoryWise.selectedStatusIds = this.$globalHelpers.pluck(this.statuses, 'id');
                    }
                })
            }
            else if(field === 'reports.summaryWise.selectedStatusIds'){
                this.$nextTick(() => {
                    if (this.reports.summaryWise.selectedStatusIds.length === this.statuses.length) {
                        this.reports.summaryWise.selectedStatusIds = []
                    } else {
                        this.reports.summaryWise.selectedStatusIds = this.$globalHelpers.pluck(this.statuses, 'id');
                    }
                })
            }
        },
        generate: async function (report_key) {
            this.showReport = true;
            this.loading = true;
            if (report_key === 'reports.dateWise') {
                this.reports.dateWise.list = [];
                await this.$axios.post(this.$globalSettings.api.endpoints.svForm.report.incentiveList, this.reports.dateWise).then(async (response) => {
                    this.loading = false;
                    if (response.data.Status === 'success') {
                        this.reports.dateWise.list = response.data.List;
                        this.reports.dateWise.count = response.data.Count;
                        this.calculateReportTotals('dateWise');
                        //console.log(updatedReport);
                        Vue.$toast.open({message: "Report Generated.", type: response.data.Status});
                    }else{
                        Vue.$toast.open({message: response.data.Msg, type: response.data.Status});
                    }
                }).catch((error) => {
                    this.loading = false;
                    this.reports.dateWise.list = [];
                    this.$globalHelpers.processHttpErrorsToast(error, true);
                });
            }
            else if (report_key === 'reports.companyWise') {
                this.reports.companyWise.list = [];
                await this.$axios.post(this.$globalSettings.api.endpoints.svForm.report.incentiveList, this.reports.companyWise).then(async (response) => {
                    this.loading = false;
                    if (response.data.Status === 'success') {
                        this.reports.companyWise.list = response.data.List;
                        this.reports.companyWise.count = response.data.Count;
                        this.reports.companyWise.companyName = response.data.ExtSt1;
                        this.calculateReportTotals('companyWise');
                        //console.log(updatedReport);
                        Vue.$toast.open({message: "Report Generated.", type: response.data.Status});
                    }else{
                        Vue.$toast.open({message: response.data.Msg, type: response.data.Status});
                    }
                }).catch((error) => {
                    this.loading = false;
                    this.reports.companyWise.list = [];
                    this.$globalHelpers.processHttpErrorsToast(error, true);
                });
            }
            else if (report_key === 'reports.categoryWise') {
                this.reports.categoryWise.list = [];
                await this.$axios.post(this.$globalSettings.api.endpoints.svForm.report.incentiveList, this.reports.categoryWise).then(async (response) => {
                    this.loading = false;
                    if (response.data.Status === 'success') {
                        this.reports.categoryWise.list = response.data.List;
                        this.reports.categoryWise.count = response.data.Count;
                        this.calculateReportTotals('categoryWise');
                        //console.log(updatedReport);
                        Vue.$toast.open({message: "Report Generated.", type: response.data.Status});
                    }else{
                        Vue.$toast.open({message: response.data.Msg, type: response.data.Status});
                    }
                }).catch((error) => {
                    this.loading = false;
                    this.reports.categoryWise.list = [];
                    this.$globalHelpers.processHttpErrorsToast(error, true);
                });
            }
            else if (report_key === 'reports.summaryWise') {
                this.reports.summaryWise.list = [];
                await this.$axios.post(this.$globalSettings.api.endpoints.svForm.report.incentiveSummary, this.reports.summaryWise).then(async (response) => {
                    this.loading = false;
                    if (response.data.Status === 'success') {
                        this.reports.summaryWise.list = response.data.List;
                        this.reports.summaryWise.count = response.data.Count;

                        //console.log(updatedReport);
                        Vue.$toast.open({message: "Report Generated.", type: response.data.Status});
                    }else{
                        Vue.$toast.open({message: response.data.Msg, type: response.data.Status});
                    }
                }).catch((error) => {
                    this.loading = false;
                    this.reports.summaryWise.list = [];
                    this.$globalHelpers.processHttpErrorsToast(error, true);
                });
            }
        },
        exportToXLSX: function (report) {
            const config = this.reportMap[report];
            if (!config) return;

            const originalTable = document.getElementById(config.elementId);
            if (!originalTable) return;

            // Clone the table to avoid modifying the original in the DOM
            const clonedTable = originalTable.cloneNode(true);

            // Get the column count from the first row
            const firstRow = clonedTable.querySelector('tr');
            const columnCount = firstRow ? firstRow.querySelectorAll('td, th').length : 1;

            // Get report-specific data
            const reportData = this.reports[config.reportKey];
            const fromDate = this.$globalHelpers.getFormattedDate(reportData.startDate, '', 'DD/MM/YYYY');
            const toDate = this.$globalHelpers.getFormattedDate(reportData.endDate, '', 'DD/MM/YYYY');

            let statusText = 'All';
            if (reportData.selectedStatusIds.length > 0) {
                statusText = reportData.selectedStatusIds.map(id => {
                    const status = this.statuses.find(s => s.id === id);
                    return this.$globalHelpers.humanize(status?.label || '');
                }).join(', ');
            }

            // Create header rows
            const headerHTML = `
                <tr><td colspan="${columnCount}" style="text-align: center;">Export Promotion Bureau</td></tr>
                <tr><td colspan="${columnCount}" style="text-align: center;">Incentive Report: &nbsp;<strong>${config.title}</strong></td></tr>
                <tr><td colspan="${columnCount}" style="text-align: center;">From: ${fromDate} To: ${toDate}</td></tr>
                <tr>
                    <td colspan="${columnCount}" style="text-align: center;">
                        ${config.reportKey === 'companyWise'? 'Company: ' + this.reports.companyWise.companyName + ' (' + this.reports.companyWise.Username + ')': ''}
                        ${config.reportKey === 'categoryWise'? 'Category: ' + this.$globalSettings.svFormIncentiveTypes.find(c => c.id === this.reports.categoryWise.incentiveTypeId).label: ''}
                        ${config.reportKey !== 'summaryWise'? 'Statuses: ' + statusText: ''}
                    </td>
                </tr>
            `;

            // Create a temporary tbody and insert at the top
            const headerWrapper = document.createElement('tbody');
            headerWrapper.innerHTML = headerHTML;

            const tableBody = clonedTable.querySelector('tbody');
            if (tableBody) {
                // Prepend each header row to the top of tbody
                Array.from(headerWrapper.children).reverse().forEach(row => {
                    tableBody.insertBefore(row, tableBody.firstChild);
                });
            } else {
                // Fallback: prepend to table if <tbody> is not present
                Array.from(headerWrapper.children).reverse().forEach(row => {
                    clonedTable.insertBefore(row, clonedTable.firstChild);
                });
            }

            // Export
            const wb = XLSX.utils.table_to_book(clonedTable, { sheet: "Sheet1" });
            XLSX.writeFile(wb, config.filenameExcel);
        },
        exportPDF: function (report) {
            this.loading = true;
            const config = this.reportMap[report];
            if (!config) {
                this.loading = false;
                return;
            }

            const element = document.getElementById(config.elementId);
            if (!element) {
                this.loading = false;
                return;
            }

            // Basic row selection
            const originalRows = Array.from(element.querySelectorAll('tbody > tr'));
            const headerRow = originalRows[0] || null; // Column titles (may be null)

            // Report-specific values used in header
            const reportData = this.reports[config.reportKey] || {};
            const fromDate = this.$globalHelpers.getFormattedDate(reportData.startDate, '', 'DD/MM/YYYY');
            const toDate = this.$globalHelpers.getFormattedDate(reportData.endDate, '', 'DD/MM/YYYY');

            let statusText = 'All';
            if (Array.isArray(reportData.selectedStatusIds) && reportData.selectedStatusIds.length > 0) {
                statusText = reportData.selectedStatusIds.map(id => {
                    const status = this.statuses.find(s => s.id === id);
                    return this.$globalHelpers.humanize(status?.label || '');
                }).join(', ');
            }

            // Detect footer row heuristically: if there's more than one row, and the last row contains 'Total' text, treat it as footer
            let footerRows = [];
            if (originalRows.length > 1) {
                const lastRow = originalRows[originalRows.length - 1];
                const lastRowText = lastRow.textContent ? lastRow.textContent.toLowerCase() : '';
                if (lastRowText.includes('total') || lastRowText.includes('total:')) {
                    footerRows = [lastRow];
                }
            }

            // Data rows are everything between the header and the footer (if present)
            const dataRows = originalRows.slice(1, originalRows.length - footerRows.length);

            // Number of data rows per PDF page chunk and container for assembled tables
            const chunkSize = 18;
            const container = document.createElement('div');

            // Recursively apply inline styles to an element and its children. This ensures styles
            // are preserved when cloning DOM nodes into the PDF container.
            const applyInlineStylesRecursively = (el) => {
                if (!el || el.nodeType !== Node.ELEMENT_NODE) return;
                // Check for <td> or <th>
                if (el.tagName === 'TD' || el.tagName === 'TH') {
                    const text = (el.textContent || '').trim();
                    if (text.length > 32) {
                        el.textContent = text.substring(0, 100) + '..';
                    }
                    el.style.fontSize = text.length > 23 ? '10px' : '12px';
                    el.style.paddingLeft = '3px';
                    el.style.paddingRight = '3px';
                } else {
                    el.style.fontSize = '12px';
                }

                for (const child of el.children) {
                    applyInlineStylesRecursively(child);
                }
            };

            // Build chunks; if there are no data rows, still create one empty chunk so header/footer render
            const chunks = [];
            if (dataRows.length === 0) {
                chunks.push([]);
            } else {
                for (let i = 0; i < dataRows.length; i += chunkSize) {
                    chunks.push(dataRows.slice(i, i + chunkSize));
                }
            }

            for (let chunkIndex = 0; chunkIndex < chunks.length; chunkIndex++) {
                const chunk = chunks[chunkIndex];
                const table = document.createElement('table');
                table.setAttribute('border', '1');
                table.setAttribute('cellspacing', '0');
                table.style.width = '100%';
                table.style.marginBottom = '20px';
                table.style.pageBreakAfter = (chunkIndex < chunks.length - 1) ? 'always' : 'auto';

                const tbody = document.createElement('tbody');
                const columnCount = headerRow ? headerRow.querySelectorAll('td, th').length : 1;

                if (chunkIndex === 0) {
                    tbody.innerHTML += `
                <tr style="border-color: #ffffff; text-align: center;">
                    <td style="border-color: #ffffff; text-align: center; padding-top: 5px;" colspan="${columnCount}">
                        <div style="width: 50%; margin: 0 auto;">
                            <div style="float: left;">
                                <img src="/images/logo.png" height="40" alt="Logo">
                            </div>
                            <div style="float: right;">
                                <img src="/images/epbLogo.jpg" height="40" alt="EPB Logo">
                            </div>
                            <div style="text-align: center; font-size: 14px">
                                <div style="font-size: 14px;">Export Promotion Bureau</div>
                                <div>TCB Building, 1 Kawran Bazar, Dhaka</div>
                            </div>
                            <div style="clear: both;"></div>
                        </div>
                    </td>
                </tr>
                <tr><td colspan="${columnCount}" style="border-color: #ffffff; text-align: center;">Incentive Report: <span class="font-bold">${config.title}</span></td></tr>
                <tr><td colspan="${columnCount}" style="border-color: #ffffff; text-align: center;">From: ${fromDate} To: ${toDate}</td></tr>
                <tr>
                    <td colspan="${columnCount}" style="border-top-color: #ffffff; border-left-color: #ffffff; border-right-color: #ffffff; text-align: center; padding-bottom: 5px;">
                        ${config.reportKey === 'companyWise'? 'Company: ' + this.reports.companyWise.companyName + ' (' + this.reports.companyWise.Username + ')': ''}
                        ${config.reportKey === 'categoryWise'? 'Category: ' + this.$globalSettings.svFormIncentiveTypes.find(c => c.id === this.reports.categoryWise.incentiveTypeId).label: ''}
                        ${config.reportKey !== 'summaryWise'? 'Statuses: ' + statusText: ''}
                    </td>
                </tr>`;
                }

                const headerClone = headerRow ? headerRow.cloneNode(true) : null;
                if (headerClone) {
                    applyInlineStylesRecursively(headerClone);
                    tbody.appendChild(headerClone);
                }

                chunk.forEach(row => {
                    const rowClone = row.cloneNode(true);
                    applyInlineStylesRecursively(rowClone);
                    tbody.appendChild(rowClone);
                });


                // Append footer rows on the last chunk
                if (chunkIndex === chunks.length - 1) {
                    footerRows.forEach(row => {
                        const rowClone = row.cloneNode(true);
                        applyInlineStylesRecursively(rowClone);
                        tbody.appendChild(rowClone);
                    });
                }

                table.appendChild(tbody);
                container.appendChild(table);
            }
            const note = document.createElement('div');
            note.style.marginTop = '10px';
            note.style.fontStyle = 'italic';
            note.style.fontSize = '12px';
            note.style.textAlign = 'center';
            note.textContent = 'Promoting Export, Building Bangladesh';
            container.appendChild(note);

            //document.getElementById('debugReport').append(container);

            const opt = {
                margin: 0.4,
                filename: config.filenamePDF,
                image: { type: 'jpeg', quality: 0.98 },
                html2canvas: { scale: 1 },
                jsPDF: { unit: 'in', format: 'a4', orientation: config.reportKey === 'summaryWise'? 'portrait': 'landscape' }
            };

            html2pdf().set(opt).from(container).save().then(() => {
                this.loading = false; // Hide spinner or update UI
            }).catch(err => {
                this.loading = false;
                console.log(err);
            });
        },
        navigationBack: async function () {
            this.$router.go(-1);
        },

        calculateReportTotals: function (reportName) {
            // Find the selected report from the reports object
            const selectedReport = this.reports[reportName];

            // If the report doesn't exist, return an error message
            if (!selectedReport) {
                console.error('Report not found');
                return;
            }

            // Initialize the totals for the selected report (using the defaultTotals keys)
            const totals = { ...selectedReport.defaultTotals };

            // Loop through the items in the report's list to calculate the sums
            selectedReport.list.forEach(item => {
                // For each key in defaultTotals, check if the key exists in the item and add the value
                Object.keys(totals).forEach(key => {
                    // Use Object.prototype.hasOwnProperty.call() to avoid direct prototype access
                    if (Object.prototype.hasOwnProperty.call(item, key)) {
                        // Convert item[key] to a number before adding (if it's a valid number)
                        totals[key] += Number(item[key]) || 0;  // Using Number() to ensure it's added as a number
                    }
                });
            });

            // Update the report's defaultTotals with the calculated totals
            selectedReport.defaultTotals = totals;

            // Return the updated report with the calculated totals
            return selectedReport;
        },

    },
    async created() {
        this.reports.dateWise.startDate = this.reports.companyWise.startDate = this.reports.categoryWise.startDate = this.reports.summaryWise.startDate = this.$globalHelpers.getFirstDayOfMonth('YYYY-MM-DD');
        this.reports.dateWise.endDate = this.reports.companyWise.endDate = this.reports.categoryWise.endDate = this.reports.summaryWise.endDate = this.$globalHelpers.getDateToday('YYYY-MM-DD');
        this.statuses = this.$globalHelpers.enumToArray(this.$globalEnums.SvFormIncentiveStatuses);
        this.reports.dateWise.selectedStatusIds.push(this.$globalEnums.SvFormIncentiveStatuses.Approved);
        this.reports.companyWise.selectedStatusIds.push(this.$globalEnums.SvFormIncentiveStatuses.Approved);
        this.reports.categoryWise.selectedStatusIds.push(this.$globalEnums.SvFormIncentiveStatuses.Approved);
        this.reports.summaryWise.selectedStatusIds.push(this.$globalEnums.SvFormIncentiveStatuses.Approved);
        this.reports.summaryWise.incentiveTypeIds = this.$globalSettings.svFormIncentiveTypes.map(item => item.id);

        this.reportType = this.$route.params.type;
        this.showReport = false;
        this.$watch(
            () => this.$route.params,
            async (toParams) => {
                this.routeParams = toParams;
                this.reportType = this.routeParams.type;
                this.showReport = false;
            }
        );
    }
}
</script>

<style scoped>

</style>